export enum Tool {
  none = "none",
  select = "select",
  opacity = "opacity",
  fullscreen = "fullscreen",
  measure = "measure",
  coordinates = "coordinates",
  paint = "paint",
  clippingBox = "clippingBox",
  drawPolygon = "drawPolygon",
  visibility = "visibility",
  controlsPreset = "controlsPreset",
  viewCreate = "viewCreate",
  layerCreate = "layerCreate",
  search = "search",
  levelOfDetailPreset = "levelOfDetailPreset",
  vectorLineWidth = "vectorLineWidth",
  elementReposition = "elementReposition",
}
